import { MenuLink } from 'interfaces';
import { PLATFORM_TYPES } from 'common/constants';

const { MOBILE, MULTIPLATFORM } = PLATFORM_TYPES;

export const isSupportedLinkPlatform = (link: MenuLink): boolean =>
  link.platform_type === MULTIPLATFORM || link.platform_type === MOBILE;
